const parseError = (error) => {
  let message = "";
  if (error.response) {
    message = error.response;
  } else if (error.request) {
    message = "Network Error!";
  } else if (error.response.status === 422) {
    message = error.response.data;
  } else {
    message = error.message;
  }

  return message;
};

export default parseError;
